import { render } from "./App.vue?vue&type=template&id=5b5d6bbc"
const script = {}
script.render = render

export default script